import React, { FC } from 'react';

import Button from '../../common/button';
import { CloseCrossBtn } from '../../icons/close-cross-btn';

interface IMobilePopupProps {
  onCancel: () => void;
  onRequest: () => void;
  className?: string;
  title: string;
  description: string;
  rejectText: string;
  acceptText: string;
}

const MobilePopup: FC<IMobilePopupProps> = ({
  onCancel,
  onRequest,
  className,
  title,
  description,
  rejectText,
  acceptText,
}) => {
  return (
    <div
      className={`fixed bottom-0 left-0 w-full p-6 bg-white shadow-shadowPopup z-50 flex flex-col gap-6 rounded-t-[20px] sm:rounded-t-[40px] ${className}`}
    >
      <div className="flex justify-between items-start">
        <h2 className="font-comfortaa text-lg text-[#111026] font-bold">{title}</h2>
        <button className="cursor-pointer" onClick={onCancel} aria-label="Закрыть">
          <CloseCrossBtn width={20} height={20} />
        </button>
      </div>

      <p className="text-sm text-[#878791] font-medium">{description}</p>

      <div className="flex gap-4">
        <Button type="grey" className="w-full px-4 py-2 text-base" onClick={onCancel}>
          {acceptText}
        </Button>
        <Button
          className="
          w-full px-4 py-2 text-base font-comfortaa font-bold
          text-white bg-redBase border-redBase
          hover:bg-redBaseWithBlur20 hover:border-redBaseWithBlur20
          active:bg-redBase active:border-redBase
        "
          onClick={onRequest}
        >
          {rejectText}
        </Button>
      </div>
    </div>
  );
};

export default MobilePopup;
